import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage "Challenge a Friend" game mode state.
 * Handles URL parameters for challenge links and challenge state.
 */
export function useChallengeMode() {
  // Check URL for challenge code on init
  const [showChallengeInfo, setShowChallengeInfo] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return !!urlParams.get('challenge');
  });
  
  const [isChallengeMode, setIsChallengeMode] = useState(false);
  const [currentChallengeCode, setCurrentChallengeCode] = useState(null);
  const [pendingChallengeCode, setPendingChallengeCode] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('challenge');
    return code ? code.toUpperCase() : null;
  });

  // Clear challenge URL parameter on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('challenge')) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Start playing a challenge
  const startChallenge = useCallback((challengeCode) => {
    setIsChallengeMode(true);
    setCurrentChallengeCode(challengeCode);
    setShowChallengeInfo(false);
    setPendingChallengeCode(null);
  }, []);

  // Close challenge info modal without starting
  const closeChallengeInfo = useCallback(() => {
    setShowChallengeInfo(false);
    setPendingChallengeCode(null);
  }, []);

  // Exit challenge mode
  const exitChallengeMode = useCallback(() => {
    setIsChallengeMode(false);
    setCurrentChallengeCode(null);
  }, []);

  return {
    // State
    isChallengeMode,
    currentChallengeCode,
    showChallengeInfo,
    pendingChallengeCode,
    
    // Actions
    startChallenge,
    closeChallengeInfo,
    exitChallengeMode,
    
    // Setters for external control
    setShowChallengeInfo,
    setPendingChallengeCode
  };
}
